import React, { useEffect } from "react";
import { Row, Col, DropdownButton, Dropdown } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import QuestionOptInputText from './QuestionInputs/text';
import QuestionOptInputNumber from './QuestionInputs/number';
import { useMappedState, useDispatch } from 'redux-react-hook';

const E_OPT_TYPE = {
    0: "文字",
    1: "數字",
    // 2: "圖片",
    // 3: "影音" //"外部影音" "嵌入式影音??"
}
const E_OPT_TYPE_KEY = {
    TEXT: 0,
    DIGIT: 1,
    // IMAGE: 2,
    // VIDEO: 3
}
export default function QuestionOptRuler(props) {
    const tmpItems = useMappedState(state => state.tmpItems);
    const questionIndex = props.questionID;
    const optIndex = props.optIndex;
    const pid = useMappedState(state => state.pid);

    // console.log(props);
    // return <div>aa</div>;
    const data = (tmpItems && tmpItems.length > questionIndex
        && null != tmpItems[questionIndex]
        && null != tmpItems[questionIndex].op
        && tmpItems[questionIndex].op.length > optIndex)
        ? tmpItems[questionIndex].op[optIndex] : null;
    const dispatch = useDispatch();

    // useEffect(() => {
    //   console.log(tmpItems);
    // });

    function onOptChange(key, e) {
        console.log("onOptChange", e);

        let tmp = [...tmpItems];
        tmp[questionIndex].op[optIndex][key] = e.target.value;
        // console.log(tmp);
        // setTmpItems(tmp);
        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
        // props.onOptChange(props.index, optIndex, optVal);
    }

    function onOptKeyChange(key, val) {
        console.log("onOptKeyChange", val);
        try {
            let tmp = [...tmpItems];
            tmp[questionIndex].op[optIndex][key] = val;
            dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
        } catch (e) {
            console.warn("[onOptKeyChange]", e.stack);
        }
    }

    function onSelect(e) {
        console.log(e);
        if (e != props.o_type) {
            let tmpType = parseInt(e);
            if (isNaN(tmpType) == false) {
                // console.log(onOptChange);

                let tmp = [...tmpItems];
                tmp[questionIndex].op[optIndex].o_type = tmpType;
                // console.log(tmp);
                // setTmpItems(tmp);
                dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
            }
        }
    }

    function render() {
        if (data == null) return (<div>No Data</div>);

        var opts = Object.keys(E_OPT_TYPE).map(function (key) {
            return <Dropdown.Item key={key} eventKey={key}>{E_OPT_TYPE[key]}</Dropdown.Item>
        });

        return (
            <Row>
                <Col xs={1}>
                    {/* {optIndex + 1} */}
                </Col>
                <Col className="text-left">
                    <Row>
                        <Col xs={4}>單位：</Col>
                        <Col xs={8}><QuestionOptInputText data={data.unit} onChange={(e) => onOptChange("unit", e)} /></Col>
                    </Row>
                    <Row>
                        <Col xs={4}>下限：</Col>
                        <Col><QuestionOptInputNumber data={data.min} onChange={(e) => onOptChange("min", e)} /></Col>
                    </Row>
                    <Row>
                        <Col xs={4}>上限：</Col>
                        <Col><QuestionOptInputNumber data={data.max} onChange={(e) => onOptChange("max", e)} /></Col>
                    </Row>
                    <Row>
                        <Col xs={4}>間隔：</Col>
                        <Col><QuestionOptInputNumber data={data.interval} onChange={(e) => onOptChange("interval", e)} /></Col>
                    </Row>
                    <Row>
                        <Col xs={4}>事件：</Col>
                        <Col><QuestionOptInputNumber data={data.na} onChange={(e) => onOptChange("na", e)} /></Col>
                    </Row>
                </Col>
                {/* <Col xs={4} sm={3} lg={2} xl={1} className="text-left pb-1">
                    <DropdownButton
                        className="btn-block no-bg text-left w-100"
                        alignleft="true"
                        size="sm"
                        variant="success"
                        title={E_OPT_TYPE[data.o_type]}
                        onSelect={onSelect}
                    >
                        {opts}
                    </DropdownButton>
                </Col> */}
                {/* <Col xs={1} className="text-right"><X onClick={props.onDelete} /></Col> */}
            </Row>
        );
    }

    return render();
}
